<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="'Customers with '+(search.isDrivingAlerts?'Driving Alerts':'Vehicle Trouble Codes')"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Phone Number</th>
                <th *ngIf="search.isVehicleAlerts">Vehicle</th>
                <th>Alerts</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of alertCustomers; let i= index">

                <td>{{i + 1}}</td>
                <td>{{item.userFullName}}</td>
                <td>{{item.userPhoneNumber}}</td>
                <td *ngIf="search.isVehicleAlerts">{{item.vehicleName}} - {{item.regNumber}}</td>
                <td *ngIf="search.isVehicleAlerts">{{item.totalVehicleAlerts}}</td>
                <td *ngIf="search.isDrivingAlerts">{{item.totalDrivingAlerts}}</td>
                <td>
                  <a *ngIf="search.isDrivingAlerts" href="javascript:void(0)" routerLink="/customers/driving-alerts"
                     [queryParams]="{name:(item.userFullName),userId:item.userId}">
                    View
                    Alerts</a>
                  <a *ngIf="search.isVehicleAlerts" href="javascript:void(0)"
                     [routerLink]="['/customers',item.userId,'vehicles',item.userVehicleId,'trouble-codes']"
                     [queryParams]="{name:(item.userFullName+' '+item.vehicleName+'-'+item.regNumber),vehicleId:item.userId}">
                    View
                    Alerts</a>
                </td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
